import { render, staticRenderFns } from "./ProducCount.vue?vue&type=template&id=57d28f24&scoped=true"
import script from "./ProducCount.vue?vue&type=script&lang=js"
export * from "./ProducCount.vue?vue&type=script&lang=js"
import style0 from "./ProducCount.vue?vue&type=style&index=0&id=57d28f24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d28f24",
  null
  
)

export default component.exports